import React from 'react'
import MainTopBar from '../../components/TopBar'
import MainFooter from '../../components/MainFooter'
import TermsOfUseChild from '../../components/TermsOfUseChild'

const TermsOfUse = () => {
    return (
        <div>
            <MainTopBar />
            <div className='container'>
                <TermsOfUseChild />
            </div>
            <MainFooter />
        </div>
    )
}

export default TermsOfUse